import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';

interface HeaderWithBcBlockThemeProps {
  title: string;
}

const styles: ComponentStylesProps<HeaderWithBcBlockThemeProps> = {
  header: {
    position: 'relative',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '5.6rem auto 5.2rem',
    maxWidth: '109.6rem',
    '@media(max-width: 840px)': {
      paddingTop: '4rem',
    },
  },
  title: {
    margin: '0 0 0.8rem',
    fontSize: '3.4rem',
    lineHeight: '4rem',
    letterSpacing: '0.02rem',

    '@media(max-width: 840px)': {
      fontSize: '2.8rem',
      lineHeight: '4rem',
    },
  },
  caption: {
    margin: { bottom: '1.2rem' },
    font: { size: '1.8rem', lineHeight: '2.8rem' },
    letterSpacing: '0.02rem',
  },
  playTutorialButton: { textTransform: 'uppercase' },
  playTutorialLink: {
    textDecoration: 'none',
  },
  backButton: {
    position: 'absolute',
    left: 0,
    top: '2.6rem',
    paddingLeft: 0,
    '@media(max-width: 840px)': {
      top: '6rem',
    },
    [breakpoints.md.down]: {
      top: '-1rem',
    },
  },
  backButtonInLine: { top: '0.7rem' },
  bcBlock: ({ title }) => ({
    minWidth: '30rem',
    backgroundColor: colors.neutral.white,
    marginBottom: title ? '2.8rem' : 0,
    marginTop: title ? '2.8rem' : 0,
    textAlign: 'center',
    maxWidth: '70%',
  }),

  '@media(max-width: 424px)': {
    // MAKE IT ONLY AS FUNCTION, otherwise styles will not be applied
    bcBlock: () => ({
      borderRadius: '5rem',
      maxWidth: '24rem',
      minWidth: '50%',
    }),
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
